<template>
  <div class="sample-page-wrapper">
    <navbar></navbar>
    <div class="bg-header-straight-small">
      <div class="container">
        <h1>Dein Profil</h1>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from '../Navbar.vue'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'cgUserHeader',
    components: {
      Navbar
    },
    props: {
    },
    methods: {
      ...mapActions([
        'getInLine'
      ])
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/CgUserHeader.vue